<template>
	<div></div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		created() {
			var query = this.$route.query;
			if(query && query.query){
				this.$router.push({
					name:query.name,
					query:JSON.parse(query.query),
				})
			}else{
				this.$router.push({
					name:'index',
				})
			}
		},
	}
</script>